<template>
	<td :class="[
			'text-no-wrap',
			'text-center',
			grey ? 'primary--text text--lighten-4' : ''
		]"
	>
		<v-row>
			<v-col cols="6">
				<template v-if="editMode && !delivery">
					<a-number-field-inline
						ref="price"
						v-model="price"
						@change="priceChange"
						@focus="$emit('focusPrice')"
						@blur="$emit('blurPrice')"
					></a-number-field-inline>
				</template>
				<template v-else-if="!delivery">
					{{ price }}
				</template>
			</v-col>
			<v-col cols="6">
				<template v-if="editMode">
					<a-number-field-inline
						ref="sum"
						v-model="sum"
						@change="sumChange"
						@focus="$emit('focusSum')"
						@blur="$emit('blurSum')"
					></a-number-field-inline>
				</template>
				<template v-else>
					{{ sum }}
				</template>
			</v-col>
		</v-row>
	</td>
</template>

<script>
	import { toStr, toNum } from '../../../js/common'
	import aNumberFieldInline from '../../base/ANumberFieldInline.vue'

	export default {
		components: {
			aNumberFieldInline,
		},
		props: {
			sumNet: [ String, Number ],
			editMode: Boolean,
			qty: String,
			grey: Boolean,
			delivery: Number,
			num: Number,
		},
		computed: {},
		data: () => ({
			price: '',
			sum: '',
		}),
		watch: {
			qty(val, old) {
				let price = toNum(this.price)
				let sum = toNum(this.sum)

				if (price == 0) {
					// console.log('line ' + this.num + ' watcher qty', old, ' => ', val)
					if (sum != 0) {
						this.price = toStr(sum / toNum(val))
					}
				}
				else if (sum == 0) {
					// console.log('line ' + this.num + ' watcher qty', old, ' => ', val)
					if (price != 0) {
						this.sumChange(toStr(price * toNum(val)))
					}
				}
			},
			sumNet(val, old) {
				// console.log('line ' + this.num + ' watcher sumNet', old, ' => ', val)
				this.sumChange(val, false)
			}
		},
		created() {
			// console.log('pr-line-quotation created')
			this.sum = this.sumNet
			this.price = toStr(toNum(this.sum) / toNum(this.qty))
		},
		methods: {
			deductVat(val) {
				// console.log('deductVat')
				if (val == 'price') {
					this.priceChange(toStr((toNum(this.price) / 1.2)), false)
				}
				else {
					this.sumChange(toStr((toNum(this.sum) / 1.2)), false)
				}
				this.$refs[val].focus()
			},
			priceChange(val, emit) {
				if (emit === undefined) emit = true

				// console.log('line ' + this.num + ' priceChange', val, 'emit:', emit)

				// this.price = val

				let qty = toNum(this.qty)

				if (qty != 0) {
					this.sum = toNum(val) * qty
					if (emit) {
						this.sum = toStr(this.sum)
						this.$emit('update:sumNet', this.sum)
					}
					else {
						this.sum = toStr(this.sum)
					}
				}
				else {
					let sum = toNum(this.sum)
					if (sum != 0) {
						qty = toStr(sum / toNum(val), 0)
						if (emit) {
							this.$emit('update:qty', qty)
						}
					}
				}
			},
			sumChange(val, emit) {
				if (emit === undefined) emit = true

				// console.log('line ' + this.num + ' sumChange', val, 'emit:', emit)
				// console.log('val', val)
				// console.log('emit', emit)

				this.sum = val

				if (emit) {
					this.$emit('update:sumNet', val)
				}
				// else {
				// 	this.sum = toStr(this.sum)
				// }

				let qty = toNum(this.qty)
				if (qty != 0) {
					this.price = toNum(val) / qty
					if (emit) {
						this.price = toStr(this.price)
						this.$emit('update:priceNet', this.price)
					}
					else {
						this.price = toStr(this.price)
					}
				}
				else {
					let price = toNum(this.price)
					if (price != 0) {
						qty = toStr(toNum(val) / price, 0)
						if (emit) {
							this.$emit('update:qty', qty)
						}
					}
				}
			},
			toStr(val) {
				return toStr(val)
			},
		}
	}
</script>

<style scoped>

</style>
